/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InputAdminTeamMember } from './InputAdminTeamMember';
import {
    InputAdminTeamMemberFromJSON,
    InputAdminTeamMemberFromJSONTyped,
    InputAdminTeamMemberToJSON,
} from './InputAdminTeamMember';

/**
 * 
 * @export
 * @interface InputAdminTeamMembers
 */
export interface InputAdminTeamMembers {
    /**
     * 
     * @type {Array<InputAdminTeamMember>}
     * @memberof InputAdminTeamMembers
     */
    members?: Array<InputAdminTeamMember>;
}

/**
 * Check if a given object implements the InputAdminTeamMembers interface.
 */
export function instanceOfInputAdminTeamMembers(value: object): boolean {
    return true;
}

export function InputAdminTeamMembersFromJSON(json: any): InputAdminTeamMembers {
    return InputAdminTeamMembersFromJSONTyped(json, false);
}

export function InputAdminTeamMembersFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminTeamMembers {
    if (json == null) {
        return json;
    }
    return {
        
        'members': json['members'] == null ? undefined : ((json['members'] as Array<any>).map(InputAdminTeamMemberFromJSON)),
    };
}

export function InputAdminTeamMembersToJSON(value?: InputAdminTeamMembers | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'members': value['members'] == null ? undefined : ((value['members'] as Array<any>).map(InputAdminTeamMemberToJSON)),
    };
}

